import React from "react"
import { Link } from "react-router-dom"
import { ArrowRight } from "lucide-react"
import SectionHeading from "./SectionHeading.jsx"
import { SERVICE_ICONS } from "../page/serviceIcons.js"
import { SERVICES, serviceHref } from "../../data/services.js"

const DEFAULT_TITLE = "Everything your digital presence needs, from one experienced team"
const DEFAULT_LEAD =
  "Engage us for a single service or an end-to-end partnership. You do not need a new website to work with us on SEO & GEO, Google Ads, AI chatbots or ongoing support."

export default function ServicesGrid({ eyebrow = "Services", title = DEFAULT_TITLE, lead = DEFAULT_LEAD }) {
  return (
    <section id="services" aria-labelledby="services-heading" className="scroll-mt-24 py-20 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <SectionHeading
          id="services-heading"
          eyebrow={eyebrow}
          title={title}
          lead={lead}
        />

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((service) => {
            const Icon = SERVICE_ICONS[service.icon]

            return (
              <li key={service.key}>
                {/* The title link covers the whole card (after:inset-0); an optional
                    highlight link sits above it so both stay keyboard reachable. */}
                <article className="group relative flex h-full flex-col rounded-xl2 border border-brand-border bg-white p-7 shadow-card transition hover:-translate-y-0.5 hover:shadow-cardStrong has-[h3_a:focus-visible]:ring-2 has-[h3_a:focus-visible]:ring-brand-primary has-[h3_a:focus-visible]:ring-offset-2">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-primarySoft text-brand-primary">
                    {Icon && <Icon aria-hidden="true" className="h-6 w-6" />}
                  </span>
                  <h3 className="mt-5 text-xl font-semibold text-brand-heading">
                    <Link
                      to={serviceHref(service)}
                      className="after:absolute after:inset-0 after:rounded-xl2 focus:outline-none focus-visible:underline"
                    >
                      {service.title}
                    </Link>
                  </h3>
                  <p className="mt-3 flex-1 leading-relaxed text-brand-textSoft">{service.summary}</p>
                  {service.highlight && (
                    <Link
                      to={service.highlight.to}
                      className="relative z-10 mt-5 flex items-center justify-between gap-3 rounded-xl border border-brand-primary/20 bg-brand-primarySoft px-4 py-3 text-sm font-semibold text-brand-heading transition hover:border-brand-primary hover:text-brand-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2"
                    >
                      {service.highlight.label}
                      <ArrowRight aria-hidden="true" className="h-4 w-4 shrink-0" />
                    </Link>
                  )}
                  <span
                    aria-hidden="true"
                    className="mt-6 inline-flex items-center gap-2 font-semibold text-brand-primary"
                  >
                    {service.cta}
                    <ArrowRight className="h-4 w-4 transition group-hover:translate-x-0.5" />
                  </span>
                </article>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}
